import { router, usePage } from '@inertiajs/react';

export const useFilters = (only = []) => {
    const { filters } = usePage().props;

    const isSorted = field => {
        if (filters.sort !== field) {
            return null;
        }

        return filters.order;
    };

    // `overrides` sets extra params in the same request, e.g. clearing a
    // dependent filter: updateFilters('filter', value, { type: null }).
    const updateFilters = (key, value, overrides = {}) => {
        const params = {
            ...filters,
            [key]: value,
            ...overrides,
        };

        if (key === 'sort' && value === filters.sort) {
            params.order = params.order === 'ASC' ? 'DESC' : 'ASC';
        }

        Object.keys(params).forEach(paramKey => {
            const paramValue = params[paramKey];

            if (
                paramValue === null ||
                paramValue === undefined ||
                paramValue === '' ||
                (Array.isArray(paramValue) && paramValue.length === 0)
            ) {
                delete params[paramKey];
            }
        });

        if (
            key !== 'page' &&
            Object.hasOwn(params, 'page') &&
            params.page !== 1
        ) {
            params.page = 1;
        }

        let replace = false;

        if (key === 'search') {
            replace = true;
        }

        router.get(window.location.pathname, params, {
            preserveState: true,
            replace,
            preserveScroll: true,
            only: ['filters', ...only],
            // Scroll/merge props append by default; changing a filter must
            // replace the accumulated data instead of adding to it.
            reset: only,
        });
    };

    return { filters, updateFilters, isSorted };
};
